module.exports = __webpack_public_path__ + "static/media/GINGER TURMERIC.43ebb01d.jpg";